import { ReactElement, useEffect } from 'react'
import {
    CheckoutActions,
    CheckoutState,
} from '@raskrask-dk/bookingflow-state-machine'
import { useBFSMValue } from '../../../services/hooks/useBFSMValues'
import PaymentMethodsTemplate from './template'
import { useAppSelector } from '../../../redux/hooks'
import { getUser } from '../../../redux/reducers/appSettings'

const PaymentMethodsPage = (): ReactElement => {
    const user = useAppSelector((state) => getUser(state))

    const [paymentMethod, setPaymentMethod] = useBFSMValue<
        CheckoutState,
        CheckoutActions.ChoosePaymentMethod,
        'paymentMethod'
    >('paymentMethod', CheckoutActions.ChoosePaymentMethod)

    // changed the bfsm const value as const were not triggering the re-render
    const paymentMethods: ['Pay Later'] | ['Mobile Pay', 'Card'] =
        user === 'admin' ? ['Pay Later'] : ['Mobile Pay', 'Card']

    useEffect(() => {
        if (user === 'admin') {
            setPaymentMethod('Pay Later')
        }
    }, [])

    return (
        <PaymentMethodsTemplate
            onClickPaymentMethod={setPaymentMethod}
            paymentMethods={paymentMethods}
            selectedPaymentMethod={paymentMethod}
        />
    )
}

export default PaymentMethodsPage
